module.exports = __webpack_public_path__ + "img/tongue-twister-layer2.1eb37f30.png";